var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bullets"},_vm._l((_vm.items),function(i){return _c('a',{key:("bullet-" + i),staticClass:"bullet-item",class:{active: i == _vm.current},on:{"click":function($event){return _vm.select(i)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }